import { createApp } from 'vue'
import { createPinia } from 'pinia'
import ElementPlus from 'element-plus'
import zhCn from 'element-plus/es/locale/lang/zh-cn'

import 'element-plus/dist/index.css'
import 'element-plus/theme-chalk/dark/css-vars.css'
import '@/styles/theme.css'

import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { icons } from '@/icons'

import App from './App.vue'
import router from './router'
import TermTip from '@/components/TermTip.vue'
import { vTerm } from '@/directives/term'

// 按需注册图标。全量引入 fas + fab 会让产物多出约 1.9 MB（gzip 约 700 KB），
// 对一个只用几十个图标的控制台不划算。新增图标时在 src/icons.js 里加一行。
library.add(...icons)

const app = createApp(App)
app.use(createPinia())
app.use(router)
app.use(ElementPlus, { locale: zhCn })
app.component('FaIcon', FontAwesomeIcon)

// 术语悬浮解释。指令给静态标签用，组件给动态文本用 —— 两者都只注入
// 标记，浮层全局共用一个（components/GlossaryTip.vue）。
app.component('TermTip', TermTip)
app.directive('term', vTerm)

app.mount('#app')
